
export type EstimationUrlParameters = { version: string; ref?: string; configId?: string; };

export class UrlHelper {

    public static toQueryParams<T extends Record<string, string | undefined>>(params: T): URLSearchParams {
        const urlSearchParams = new URLSearchParams();
        const addQuery = (key: string, value: string = '') => {
            if (Boolean(value)) {
                urlSearchParams.append(key, value);
            } else {
                urlSearchParams.delete(key);
            }
        }

        Object.keys(params).forEach(key => addQuery(key, params[key]));
        return urlSearchParams;
    }

    public static withQueryParams<T extends Record<string, string | undefined>>(baseUrl: string, params: T): string {
        const url = new URL(baseUrl);
        const searchParams = UrlHelper.toQueryParams<T>(params);
        url.search = searchParams.toString();
        return url.toString();
    }

    public static getQueryParams<T extends Record<string, string | undefined>>(): T {
        const params = new URLSearchParams(window.location.search);
        const result: Record<string, string | undefined> = {};
        params.entries()
            .filter(([key, value]) => Boolean(value))
            .forEach(([key, value]) => result[key] = value);
        return result as T;
    }
}